import { sort } from "@client/lib/array";
import { joinDefined } from "@client/lib/misc";
import { type Validation } from "@common/controls/Form/component";
import { SystemColor } from "@common/declarations";
import { type MemberHelpdesk } from "./types";

export interface OptInFormField {
  id: number;
  label: string;
  name: string;
  type: string;
  options: any;
  width: string;
  validation: Validation;
  value: any;
}

export const getTicketStatusBadgeType = (key: MemberHelpdesk.TicketStatus | undefined): SystemColor => {
  switch (key) {
    case "Active":
      return SystemColor.Blue;
    case "Closed":
      return SystemColor.Gray;
    case "Waiting":
      return SystemColor.Red;
    case "Resolved":
      return SystemColor.Green;
    default:
      return SystemColor.Gray;
  }
};

export const mapUserName = (data: { userFirstName: string | null; userLastName: string | null }): string | null => {
  return joinDefined(" ", data.userFirstName, data.userLastName) || null;
};

export const sortTickets = (tickets: MemberHelpdesk.Api.Ticket[]): MemberHelpdesk.Api.Ticket[] => [
  ...sort(
    tickets.filter((x) => x.ticketStatusKey === "Waiting"),
    { key: "lastModifiedOnDate", type: "date", order: "desc" }
  ),
  ...sort(
    tickets.filter((x) => x.ticketStatusKey === "Active"),
    { key: "lastModifiedOnDate", type: "date", order: "desc" }
  ),
  ...sort(
    tickets.filter((x) => x.ticketStatusKey === "Resolved"),
    { key: "lastModifiedOnDate", type: "date", order: "desc" }
  ),
  ...sort(
    tickets.filter((x) => x.ticketStatusKey === "Closed"),
    { key: "lastModifiedOnDate", type: "date", order: "desc" }
  )
];
